<img class="table-images" src="{{params.value?.image_src}}"/>
